import { render, staticRenderFns } from "./SettingsEmailTemplateBuilderPage.vue?vue&type=template&id=5526b870"
import script from "./SettingsEmailTemplateBuilderPage.vue?vue&type=script&lang=ts"
export * from "./SettingsEmailTemplateBuilderPage.vue?vue&type=script&lang=ts"
import style0 from "./SettingsEmailTemplateBuilderPage.vue?vue&type=style&index=0&id=5526b870&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports